import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SwiperConfig } from 'src/app/config/swiper.config';
import { CityModel } from 'src/app/models/city.model';
import { StateModel } from 'src/app/models/state.model';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-swiper-cities',
  templateUrl: './swiper-cities.component.html',
  styleUrls: ['./swiper-cities.component.scss']
})
export class SwiperCitiesComponent {
  public citiesSwiperConfig: SwiperOptions = SwiperConfig.states;
  public states: StateModel[] = [];

  @Input() 
  set cities(values: CityModel[]) {
    this.states = values.map(city => city.state)
      .filter((state, index, self) => 
        index === self.findIndex((s) => s.id === state.id)
      );
  }

  @Output() sendSelectedState: EventEmitter<StateModel> = new EventEmitter();

  selectedState(state: StateModel): void {
    this.sendSelectedState.emit(state);
  }
}
